
import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { FaqComponent } from './modules/faq/faq.component';
import { HowToBuyComponent } from './modules/landing/how-to-buy/how-to-buy.component';
import { LandingCardsComponent } from './modules/landing/landing-cards/landing-cards.component';
import { LandingComponent } from './modules/landing/landing/landing.component';
import { PaymentInfoComponent } from './modules/landing/payment-info/payment-info.component';
import { SharedModule } from './shared';
import { LoginWrapperComponent } from './shared/layout/login/login.wrapper.component';


registerLocaleData(localeEs);

@NgModule({
    declarations: [
        AppComponent,
        FaqComponent,
        LandingComponent,
        HowToBuyComponent,
        PaymentInfoComponent,
        LandingCardsComponent,
        LoginWrapperComponent
    ],
    imports: [
        AppRoutingModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        CoreModule,
        SharedModule
    ],
    providers: [],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
